import { jsx as s, jsxs as i } from "react/jsx-runtime";
import { C as n, D as c } from "./react-icons.esm-CDi78UIJ.js";
import { S as l } from "./index-B_6_jmOO.js";
import { $ as t } from "./utils-CTvPli9r.js";
import { forwardRef as o } from "react";
const d = o(({ ...e }, r) => /* @__PURE__ */ s("nav", { ref: r, "aria-label": "breadcrumb", ...e }));
d.displayName = "Breadcrumb";
const p = o(
  ({ className: e, ...r }, a) => /* @__PURE__ */ s(
    "ol",
    {
      ref: a,
      className: t(
        "flex flex-wrap items-center gap-1.5 break-words text-sm text-muted-foreground sm:gap-2.5",
        e
      ),
      ...r
    }
  )
);
p.displayName = "BreadcrumbList";
const u = o(
  ({ className: e, ...r }, a) => /* @__PURE__ */ s("li", { ref: a, className: t("inline-flex items-center gap-1.5", e), ...r })
);
u.displayName = "BreadcrumbItem";
const b = o(({ asChild: e, className: r, ...a }, m) => /* @__PURE__ */ s(e ? l : "a", { ref: m, className: t("transition-colors hover:text-foreground", r), ...a }));
b.displayName = "BreadcrumbLink";
const f = o(
  ({ className: e, ...r }, a) => /* @__PURE__ */ s(
    "span",
    {
      ref: a,
      role: "link",
      "aria-disabled": "true",
      "aria-current": "page",
      className: t("font-normal text-foreground", e),
      ...r
    }
  )
);
f.displayName = "BreadcrumbPage";
const N = ({ children: e, className: r, ...a }) => /* @__PURE__ */ s("li", { role: "presentation", "aria-hidden": "true", className: t("[&>svg]:size-3.5", r), ...a, children: e ?? /* @__PURE__ */ s(n, {}) });
N.displayName = "BreadcrumbSeparator";
const B = ({ className: e, ...r }) => /* @__PURE__ */ i(
  "span",
  {
    role: "presentation",
    "aria-hidden": "true",
    className: t("flex h-9 w-9 items-center justify-center", e),
    ...r,
    children: [
      /* @__PURE__ */ s(c, { className: "size-4" }),
      /* @__PURE__ */ s("span", { className: "sr-only", children: "More" })
    ]
  }
);
B.displayName = "BreadcrumbElipssis";
export {
  d as Breadcrumb,
  B as BreadcrumbEllipsis,
  u as BreadcrumbItem,
  b as BreadcrumbLink,
  p as BreadcrumbList,
  f as BreadcrumbPage,
  N as BreadcrumbSeparator
};
//# sourceMappingURL=breadcrumb.js.map
